import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ServiceService } from 'src/app/Services/services/service.service';

@Component({
  selector: 'app-i-proof',
  templateUrl: './i-proof.component.html',
  styleUrls: ['./i-proof.component.scss']
})
export class IProofComponent implements OnInit {

  referenceNumber = '';
  UploadKey = '';
  role = '';
  uploadMessage = '';
  uploadrefmessage = '';
  file!: File;
  isloader = false;
  upload: any[] = [];
  errorupload: any[] = [];
  response: any[] = [];
  package_massage = '';
  file_res = '';
  refId = '';
  ABC = { Id: '123456' }; // example value, set dynamically
  toastr: any;
  uploadType: any;
  DownloadText: any;
  multiDownloadFilter: string = '';
  DownloadTextmulti: any;
  UploadPack = false;
  singlecont = false;
  Multiplecont = false;
  selectedOption = ''
  Upadte = false;
  Single = false;
  Multiple = false;
  isDownloading: boolean = false;
  isMultiDownload: boolean = false;
  UccDownload: boolean = false;
  UccMultiDownload: boolean = false
  DownloadUCCText: any;
  DownloadTextUCC: any;

  ngOnInit(): void {
  }

  constructor(private apiService: ServiceService, private http: HttpClient) { }

  options = [
    { name: 'Upload Package' },
    { name: 'Single Download' },
    { name: 'Multiple Download' },
    { name: 'UCC Single Download'},
    { name : 'UCC Multiple Download'}
  ];

  onOptionChange(): void {
    debugger
    this.Upadte = false;
    this.Single = false;
    this.Multiple = false;
    this.UccDownload = false;
    this.UccMultiDownload = false;

    switch (this.selectedOption) {
      case 'Upload Package':
        this.Upadte = true;
        break;

      case 'Single Download':
        this.Single = true;
        break;

      case 'Multiple Download':
        this.Multiple = true;
        break;

      case 'UCC Single Download':
        this.UccDownload = true;
        break;
        
      case 'UCC Multiple Download':
        this.UccMultiDownload = true;
        break;
    }
  }

  onFileSelected(event: any): void {
    this.file = event.target.files[0];
  }

  formSubmitted = false;
  isUploading = false;

  uploadFile(): void {
    debugger
    this.formSubmitted = true;
    this.isUploading = true;

    console.log(this.uploadType)
    if (!this.file || !this.referenceNumber || !this.uploadType || !this.UploadKey) {
      this.uploadMessage = '❌ Reference Number and file are required.';
      return;
    }

    this.isloader = true;

    this.apiService.uploadInput(this.file, this.UploadKey, this.referenceNumber, this.uploadType).subscribe(
      (res: any) => {
        console.log('Responce:', res);
        // Handle the response based on expected structure
        let refNumber = res?.ReferenceNumber;

        if (res?.Message && res?.ReferenceNumber) {
          this.uploadMessage = `✅ Success: ${res.Message}\n `;
          this.uploadrefmessage = `✅ ReferenceNumber: ${refNumber}`;
        } else if (res.includes('JatsXml Conversion')) {
          this.uploadMessage = `✅ Success: ${res}\n `;
        } else {
          this.uploadMessage = '✅ Success: File uploaded, but no message returned.';
        }
        this.isUploading = false;
        this.referenceNumber = '';
        this.UploadKey = '';
        this.role = '';
        this.uploadType = '';
        const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
        if (fileInput) fileInput.value = ''
        this.formSubmitted = false;
      },
      (error: any) => {
        this.isUploading = false;
        this.uploadMessage = `❌ Error: ${error.error}`;
      }
    );
  }

  onClick() {
    debugger
    let key = this.DownloadText;
    if (!key || key.trim() === '') {
      alert('Insert Reference Number');
      return;
    }
    this.isDownloading = true;

    this.apiService.getDownload(key).subscribe(
      (response) => {
        let blob = response.body!;
        let contentDisposition = response.headers.get('Content-Disposition') || '';
        console.log('Content-Disposition:', contentDisposition);

        let filename = 'downloaded-file.zip';
        let match = contentDisposition.match(/filename\*?=(?:UTF-8''|")(.*?)(?=[";])/);
        if (match && match[1]) {
          filename = decodeURIComponent(match[1]);
        } else {
          match = contentDisposition.match(/filename=([^;]+)/);
          if (match && match[1]) {
            filename = match[1].trim().replace(/["']/g, '');
          }
        }

        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        this.DownloadText = '';
      },
      (error) => {
        console.error('Download failed:', error);
        this.isDownloading = false;
      },
      () => {
        this.isDownloading = false;
      }
    );
  }

  async OnMultiple(): Promise<void> {
    debugger
    const rawText = this.DownloadTextmulti?.trim();
    if (!rawText) {
      console.warn('Folder path is empty');
      return;
    }
    this.isMultiDownload = true;

    const folderPaths = rawText
      .split(/\r?\n|,/g) // split by new lines or commas
      .map((p: any) => p.trim())
      .filter((p: any) => p && p !== 'OPS_Editor' && p !== 'OPS_Editor/'); // clean and filter

    if (folderPaths.length === 0) {
      console.warn('No valid folder paths found');
      return;
    }

    for (const folderPath of folderPaths) {
      console.log('Fetching files from:', folderPath);
      try {
        const files = await this.apiService.getMultipleFile(folderPath).toPromise();
        console.log(files)
        await this.downloadAllFiles(files); // download files in that folder
      } catch (err) {
        console.error(`Failed to get files for folder: ${folderPath}`, err);
        this.isMultiDownload = false;
      }
      await this.delay(500); // throttle between folder requests
    }
    this.isMultiDownload = false;
  }

  async OnUccMultiple(): Promise<void> {
    debugger
    const rawText = this.DownloadTextUCC?.trim();
    if (!rawText) {
      console.warn('Folder path is empty');
      return;
    }
    this.isMultiDownload = true;

    const folderPaths = rawText
      .split(/\r?\n|,/g) // split by new lines or commas
      .map((p: any) => p.trim())
      .filter((p: any) => p && p !== 'OPS_Editor' && p !== 'OPS_Editor/'); // clean and filter

    if (folderPaths.length === 0) {
      console.warn('No valid folder paths found');
      return;
    }

    for (const folderPath of folderPaths) {
      console.log('Fetching files from:', folderPath);
      try {
        const files = await this.apiService.getMultipleUccFile(folderPath).toPromise();
        await this.downloadAllFiles(files); // download files in that folder
      } catch (err) {
        console.error(`Failed to get files for folder: ${folderPath}`, err);
        this.isMultiDownload = false;
      }
      await this.delay(500); // throttle between folder requests
    }
    this.DownloadTextUCC = '';
    this.isMultiDownload = false;
  }

  async downloadAllFiles(fileList: any[]) {
    for (let file of fileList) {
      this.triggerDownload(file.url, file.fileName);
      await this.delay(500); // wait 500ms between downloads
    }
  }

  triggerDownload(fileUrl: string, fileName: string): void {
    const a = document.createElement('a');
    a.href = fileUrl;
    a.download = fileName || '';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  onUCCDownloadClick() {
    debugger
    this.isDownloading = true;
    let uccText = this.DownloadUCCText;
    this.apiService.getUCCDownload(uccText).subscribe(
      (response) => {
        console.log('UCCDOWNLOAD RESPONSE:',response)
        let blob = response.body!;
        let contentDisposition = response.headers.get('Content-Disposition') || '';
        console.log('Content-Disposition:', contentDisposition);

        let filename = 'downloaded-file.zip';
        let match = contentDisposition.match(/filename\*?=(?:UTF-8''|")(.*?)(?=[";])/);
        if (match && match[1]) {
          filename = decodeURIComponent(match[1]);
        } else {
          match = contentDisposition.match(/filename=([^;]+)/);
          if (match && match[1]) {
            filename = match[1].trim().replace(/["']/g, '');
          }
        }
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        this.isDownloading = false;
      },
      (error) => {
        console.log(error)
        this.isDownloading = false;
      }
    )
  }

}
